import { useEffect, useMemo, useRef } from 'react';

import { debounce, isEqual, cloneDeep } from 'lodash';

import { isValidMeta } from '../helpers';

export function useDebouncedSetFilters({ trigger, watch }, setFilters, delay = 500) {
  const prevValuesRef = useRef(null);

  const debouncedApply = useMemo(
    () => debounce(async (values) => {
      const isValid = await trigger();
      if (!isValid) return;

      // Проверяем, есть ли поле meta в объекте values
      const hasMeta = Array.isArray(values.meta);

      // Если meta есть — фильтруем валидные
      const metaValid = hasMeta ? values.meta.filter(isValidMeta) : [];

      // Проверяем, есть ли вообще какие-то значения, учитывая meta (если есть)
      const hasValues = Object.entries(values).some(([key, value]) => {
        if (key === 'meta') return metaValid.length > 0;
        if (Array.isArray(value)) return value.length > 0;
        if (typeof value === 'object' && value?.label) return true;
        return !!value;
      });

      const result = hasValues ? cloneDeep(values) : null;
      setFilters(result);
    }, delay),
    [setFilters, trigger, delay],
  );

  useEffect(() => {
    const subscription = watch((currentValues) => {
      // отсекаем дублирующиеся значения до дебаунса
      if (isEqual(prevValuesRef.current, currentValues)) return;

      prevValuesRef.current = cloneDeep(currentValues);
      debouncedApply(currentValues);
    });

    return () => {
      subscription.unsubscribe();
      debouncedApply.cancel();
    };
  }, [watch, debouncedApply]);
}
